import React from 'react';

interface ContentfulTextProps {
  content?: string | number | boolean | null | undefined | any;
  fallback: string;
  className?: string;
  as?: React.ElementType;
  onClick?: () => void;
}

/**
 * ContentfulText component that wraps text content from Contentful
 * with fallback support and preserves all styling
 */
export const ContentfulText: React.FC<ContentfulTextProps> = ({ 
  content, 
  fallback, 
  className, 
  as: Component = 'span',
  onClick,
  ...props
}) => {
  // Convert content to string if it's not null/undefined
  const displayText = content != null ? String(content) : fallback;
  
  return (
    <Component className={className} onClick={onClick} {...props}>
      {displayText}
    </Component>
  );
};

interface ContentfulMultilineTextProps extends ContentfulTextProps {
  separator?: string;
}

/**
 * ContentfulMultilineText component for handling text with line breaks
 * Preserves formatting from Contentful
 */
export const ContentfulMultilineText: React.FC<ContentfulMultilineTextProps> = ({ 
  content, 
  fallback, 
  className, 
  as: Component = 'div',
  separator = '\n',
  ...props
}) => {
  const displayText = content != null ? String(content) : fallback;
  const lines = displayText.split(separator);
  
  if (lines.length === 1) {
    return (
      <Component className={className} {...props}>
        {displayText}
      </Component>
    );
  }
  
  return (
    <Component className={className} {...props}>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </Component>
  );
};